export const messageLayoutList = [
  {
    name : '기본',
    value : 'DEFAULT',
  },
  {
    name : '수평 정렬',
    value : 'HP',
  },
  {
    name : '수평 스크롤',
    value : 'HS',
  },
  {
    name : '수직 정렬',
    value : 'VP',
  },
  {
    name : '수직 스크롤',
    value : 'VS',
  },
]